export default __webpack_public_path__ + "static/media/Agustin.6278b2ce.jpeg";